import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames/bind';
import { ColorNames } from '../../../constants/colorVars';
import Icon from '../icon';
import Text from '../text';
import CardContainer from '../cardContainer';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const CardIconTitle = ({ elmId, iconProps, title, body, }) => {
    return (_jsx("div", { className: cx('u-stretch'), children: _jsxs(CardContainer, { elmId: elmId, borderRadius: 'medium', padding: 'medium', dropShadow: 'medium', children: [_jsxs("div", { className: cx('title-wrapper'), children: [_jsx(Icon, { className: cx('u-mr-2'), size: 'big', iconStyle: 'regular', name: iconProps.name, color: iconProps.color }), _jsx(Text, { size: 'huge', weight: 'heavy', children: title })] }), _jsx(Text, { color: ColorNames.Gray, children: body })] }) }));
};
export default CardIconTitle;
//# sourceMappingURL=index.js.map